import { useDispatch, useSelector } from "react-redux";
import { useRef, useCallback } from "react"
import { ClickAway } from "@netapp/bxp-design-system-react";
import Input from "./Input";
import { isGlobalSearchCloseSuppressed, ObjectTypeFilterProvider } from "./objectTypeFilter";
import Results from "./Results";
import styles from "../GlobalSearch.module.scss";

const Component = () => {
    const dispatch = useDispatch();
    const isOpen = useSelector(state => state.globalSearch.isOpen);
    const isSearchPerformed = useSelector(state => state.globalSearch.isSearchPerformed);
    const globalSearchRef = useRef(null);
    const focusGlobalSearch = useCallback(() => {
        globalSearchRef?.current?.focus();
    }, []);

    const isExpanded = isOpen || isSearchPerformed;

    return <ObjectTypeFilterProvider>
        <div className={isExpanded ? `${styles.wrapper} ${styles.expanded}` : styles.wrapper}>
            <ClickAway ignoreParentClick listener={event => {
                if(!isExpanded) {
                    return;
                }
                if (isGlobalSearchCloseSuppressed()) {
                    return;
                }
                const target = event?.target;
                if (typeof target?.closest === "function" && target.closest('[class*="Popover-module_popover"]')) {
                    return;
                }
                dispatch({
                    type: "GLOBAL-SEARCH/CLOSE"
                });
            }}/>
            <Input ref={globalSearchRef}/>
            {(isOpen || isSearchPerformed) && <Results focusGlobalSearch={focusGlobalSearch}/>}
        </div>
    </ObjectTypeFilterProvider>
};

export default Component;
